import { Button } from "@mui/material";
import { useDialog } from "../hooks/useDialog";
import {
  DocumentHistoricalAppointmentDialog,
  type DocumentHistoricalAppointmentTab,
} from "../dialogs/DocumentHistoricalAppointmentDialog";

export function DocumentHistoricalAppointmentButton({ tabs }: { tabs: DocumentHistoricalAppointmentTab[] }) {
  const { dialogProps, openDialog } = useDialog();

  return (
    <>
      <Button variant="outlined" onClick={openDialog}>
        Termin dokumentieren
      </Button>
      <DocumentHistoricalAppointmentDialog {...dialogProps} tabs={tabs} />
    </>
  );
}
